import { render, staticRenderFns } from "./UnitPayloadDate.vue?vue&type=template&id=bb443ebe&"
import script from "./UnitPayloadDate.vue?vue&type=script&lang=js&"
export * from "./UnitPayloadDate.vue?vue&type=script&lang=js&"
import style0 from "./UnitPayloadDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports